import { render, staticRenderFns } from "./infrared-detector.vue?vue&type=template&id=1df3fcf2&scoped=true"
import script from "./infrared-detector.vue?vue&type=script&lang=js"
export * from "./infrared-detector.vue?vue&type=script&lang=js"
import style0 from "./infrared-detector.vue?vue&type=style&index=0&id=1df3fcf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df3fcf2",
  null
  
)

export default component.exports